<template>
    <div>
        <div
            class="absolute top-6 right-6 h-15 w-15 cursor-pointer button--secondary !p-0"
            :class="{ 'hidden' : open }"
            @click="openPopUp">
            <icon class="w-6 h-6 transition-transform transform fill-current"
                  name="expand-arrows" />
        </div>
        <Teleport to="body">
            <div class="z-50 fixed top-0 left-0 w-screen h-screen bg-white bg-opacity-80"
                 v-show="open">
                <div class="relative">
                    <div class="absolute top-8 right-8 flex h-15 w-15 cursor-pointer button--secondary !p-0"
                         @click="closePopUp">
                        <icon class="w-6 h-6 fill-current"
                              name="close" />
                    </div>
                </div>
                <div class="flex h-full w-full items-center justify-center">
                    <div class="w-full select-none py-24">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script lang="ts">
import Icon from './Icon.vue';
import Teleport from 'vue2-teleport';
export default {
    components: {
        Teleport,
        Icon
    },
    data() {
        return {
            open: false
        };
    },
    methods: {
        openPopUp() {
            document.body.classList.toggle('overflow-hidden', true);
            this.open = true;
        },
        closePopUp() {
            document.body.classList.toggle('overflow-hidden', false);
            this.open = false;
        }
    }
};
</script>
